import {
  Box,
  Grid,
  Typography,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import CustomTypography from "../../globalStyles/fonts";

const BillingAddressForm = ({
  billingAddress,
  setBillingAddress,
  isBillingAddress,
  setIsBillingAddress,
  handleSave,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBillingAddress((prev) => ({ ...prev, [name]: value }));
  };

  const fields = [
    "name",
    "address1",
    "address2",
    "city",
    "province",
    "country",
    "zipcode",
  ];
  const handleUpdate = async () => {
    try {
      await handleSave();
      setIsBillingAddress(false);
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <Box>
      <Box
        sx={{
          borderRadius: "8px",
          marginTop: "20px",
          padding: "20px",
          backgroundColor: "var(--bg-paper)",
          width: "99%",
          position: "relative",
          borderBottom: "0.5px solid var(--border-color)",
        }}
      >
        <Grid container spacing={2}>
          <CustomTypography
            style={{ fontWeight: 600, padding: 2, color: "#5D5FEF" }}
            variant="body1"
          >
            Billing Address
          </CustomTypography>

          {fields.map((field) => (
            <Grid item container key={field}>
              <Grid item xs={5}>
                <Typography
                  fontWeight={500}
                  fontFamily="poppins"
                  textAlign="start"
                >
                  {field.charAt(0).toUpperCase() + field.slice(1)}
                </Typography>
              </Grid>
              <Grid item xs={7}>
                {isBillingAddress ? (
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    name={field}
                    value={billingAddress?.[field] || ""}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography
                    fontWeight={500}
                    fontFamily="Poppins"
                    textAlign="start"
                    color="var(--text-primary)"
                  >
                    : {billingAddress?.[field] || "-"}
                  </Typography>
                )}
              </Grid>
            </Grid>
          ))}

          {!isBillingAddress && (
            <Grid item xs={2} sx={{ position: "absolute", right: 1, top: -15 }}>
              <IconButton onClick={() => setIsBillingAddress(true)}>
                <DriveFileRenameOutlineIcon sx={{ color: "primary.main" }} />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Box>

      {isBillingAddress && (
        <Box
          sx={{
            margin: 2,
            width: "95%",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Button
            style={{ marginRight: 15, color: "red", borderColor: "red" }}
            variant="outlined"
            onClick={() => setIsBillingAddress(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleUpdate}>
            Update
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default BillingAddressForm;
